import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "bookmark",
  initialState: {
    bookmarkList: [],
    pending: false,
    error: false,
  },
  reducers: {
    processStart: (state) => {
      state.pending = true;
      state.error = false;
    },
    addSuccess: (state, action) => {
      if (!state.bookmarkList.includes(action.payload)) {
        state.bookmarkList.push(action.payload);
      }
      state.pending = false;
    },
    removeSuccess: (state, action) => {
      const index = state.bookmarkList.indexOf(action.payload);
      state.bookmarkList.splice(index, 1);
      state.pending = false;
    },
    processError: (state) => {
      state.pending = false;
      state.error = true;
    },
    loadSuccess: (state, action) => {
      state.bookmarkList = action.payload;
      state.pending = false;
    },
  },
});

export const {
  addSuccess,
  removeSuccess,
  processStart,
  processError,
  loadSuccess
} = userSlice.actions;

export default userSlice.reducer;
